<template>
  <v-layout
    wrap
    justify-center
  >
    <v-flex
      v-if="$apollo.loading"
      text-center
    >
      <v-progress-circular
        :size="40"
        color="primary"
        class="mb-2"
        indeterminate
      /><br>
      <b>{{ $t('packs.almostDone') }}</b>
    </v-flex>
    <v-flex
      v-if="!$apollo.loading"
    >
      <iframe
        v-if="signed_url !== null"
        frameborder="0"
        height="480"
        :src="signed_url"
        allow="accelerometer; autoplay; camera; gyroscope; payment"
        width="100%"
      >
        <p>Your browser does not support iframes.</p>
      </iframe>
    </v-flex>
  </v-layout>
</template>

<script>
const MOONPAY_CONFIG = require("@/graphql/queries/MoonpayConfig.gql");
const MOONPAY_SIGN_URL = require("@/graphql/mutations/MoonpaySignUrl.gql");

import { mapGetters } from "vuex";

export default {
  name: "Moonpay",
  props: {
    invoice: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      loading: false,
      signed_url: null
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    url() {
      if (!this.moonpayConfig) return;
      let params = {
        apiKey: this.moonpayConfig.api_key,
        currencyCode: this.invoice.currency.toLowerCase(),
        baseCurrencyAmount: this.invoice.total,
        baseCurrencyCode: "usd",
        email: this.getUser.email,
        externalTransactionId: this.invoice.id,
        walletAddress: this.moonpayConfig.wallet,
        colorCode: "#0436af"
      };
      let out = [];
      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          out.push(key + "=" + encodeURIComponent(params[key]));
        }
      }
      return this.moonpayConfig.url + "?" + out.join("&");
    }
  },
  mounted() {
    this.runMoonPaySafariFix();
  },
  methods: {
    runMoonPaySafariFix() {
      var isSafari = navigator.userAgent.indexOf("Safari") > -1;

      if (!isSafari) {
        return;
      }

      var isChrome = navigator.userAgent.indexOf("Chrome") > -1;

      if (isChrome) {
        return;
      }

      if (!document.cookie.match(/^(.*;)?\s*moonpay-fixed\s*=\s*[^;]+(.*)?$/)) {
        document.cookie =
          "moonpay-fixed=fixed; expires=Tue, 19 Jan 2038 03:14:07 UTC; path=/";
        window.location.replace("https://buy.moonpay.io/safari_fix");
      }
    }
  },
  apollo: {
    moonpayConfig: {
      query: MOONPAY_CONFIG,
      result(data) {
        if (data.loading == false) {
          this.$apollo
            .mutate({
              mutation: MOONPAY_SIGN_URL,
              variables: {
                url: this.url
              }
            })
            .then(data => {
              this.signed_url = data.data.moonpaySignUrl.signed_url;
            });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped >
</style>
